import { createFileRoute } from '@tanstack/react-router';

import { appRequestsRouteSearchSchema } from '../features/supply/apps/appRequestsRouteSearch';
import { PublisherAppRequestsTable } from '../features/supply/publishers/components/PublisherAppRequestsTable';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details/app-requests')({
  validateSearch: appRequestsRouteSearchSchema,
  component: PublisherAppRequestsRoute,
});

function PublisherAppRequestsRoute() {
  const { publisherId } = Route.useParams();
  return <PublisherAppRequestsTable publisherId={publisherId} />;
}
